var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3799 3.88V10.88H19.3799V3.88H12.3799ZM17.8799 9.38H13.8799V5.38H17.8799V9.38Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87988 10.88H10.8799V3.88H3.87988V10.88ZM5.37988 5.38H9.37988V9.38H5.37988V5.38Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87988 19.38H10.8799V12.38H3.87988V19.38ZM5.37988 13.88H9.37988V17.88H5.37988V13.88Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1299 12.38H12.3799V14.13H14.1299V12.38Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 12.38H15.8799V14.13H17.6299V12.38Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 14.13H14.1299V15.88H15.8799V14.13Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3799 14.13H17.6299V15.88H19.3799V14.13Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1299 15.88H12.3799V17.63H14.1299V15.88Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6299 15.88H15.8799V17.63H17.6299V15.88Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 17.63H14.1299V19.38H15.8799V17.63Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3799 17.63H17.6299V19.38H19.3799V17.63Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.22a0fb4d21664e862f59db759fb6a3c8.svg";
export { ForwardRef as ReactComponent };